<template>
  <div>
    <my-header></my-header>
    <teaching-subject v-if="type === 'subject'" ref="teachingSubject"></teaching-subject>
    <teaching-thesis v-if="type === 'thesis'" ref="teachingThesis"></teaching-thesis>
    <my-footer></my-footer>
  </div>
</template>

<script>
import teachingSubject from './teaching/subject'
import teachingThesis from './teaching/thesis'
import myFooter from './myFooter.vue'
import myHeader from './myHeader.vue'
import { bus } from '@/router/index'
export default {
  name: 'teaching',
  components: {
    myHeader,
    myFooter,
    teachingSubject,
    teachingThesis
  },
  data () {
    return {
      type: 'subject'
    }
  },
  created () {
    bus.$on('teachingPage', () => {
      this.type = localStorage.getItem('teaching') || 'subject'
    })
    bus.$on('teachingScroll', val => {
    //   let child = 'teachingSubject'
    //   if (this.type === 'thesis') {
    //     child = 'teachingThesis'
    //   }
    //   this.$refs[child].$emit('pageScroll', val)
    })
  },
  beforeDestroy () {
    bus.$off('teachingPage')
    // bus.$off('applicationsScroll')
  },
  mounted () {
    this.type = localStorage.getItem('teaching') || 'subject'
  },
  methods: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/teaching.vue